import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";
import type { WeightLogRow } from "@/lib/database.types";

export function useWeightLogs(patientId: string | undefined) {
  return useQuery<WeightLogRow[]>({
    queryKey: ["weight_logs", patientId],
    enabled: !!patientId,
    queryFn: async () => {
      const { data, error } = await supabase
        .from("weight_logs")
        .select("*")
        .eq("patient_id", patientId!)
        .order("recorded_at", { ascending: false });
      if (error) throw error;
      return (data as WeightLogRow[] | null) ?? [];
    },
  });
}
